import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import styles from './style.module.css';

import { useAuth } from '../../../configs/context/AuthContext';

import { faBars } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Button } from '../../elements';
import BrandLogo from '../../../assets/img/watertools-logo.png';

export default function Navbar({ setShowLoginModal }) {
  const { isLogin, logout } = useAuth();
  const [isMobileNavShow, setIsMobileNavShow] = useState(false);

  const handleToggleHamburger = () => {
    setIsMobileNavShow(!isMobileNavShow);
  };

  const handleLogout = async (e) => {
    e.preventDefault();

    try {
      await logout();
    } catch {
      alert('Failed to log out');
    }
  };

  return (
    <div className={styles.root}>
      <div className={styles.navbarWrapper}>
        <div className={styles.brandLogo}>
          <img src={BrandLogo} alt="Brand Logo Pertamina Watertools" />
        </div>
        <div className={styles.navigationMenu}>
          <ul>
            <li>
              <Link to="/">Home</Link>
            </li>
            <li>
              <Link to="/about">About</Link>
            </li>
            <li>
              <Link to="/dashboard">My Dashboard</Link>
            </li>
          </ul>
        </div>
        <div className={styles.navbarButtonWrapper}>
          {isLogin ? (
            <Button label="Log Out" color="primary" onClick={handleLogout} />
          ) : (
            <>
              <Button
                label="Log In"
                color="primary"
                onClick={() => setShowLoginModal(true)}
              />
              <Button
                label="Sign Up"
                color="secondary"
                className={styles.btnSignup}
              />
            </>
          )}
        </div>

        <div
          className={`${styles.mobileNavigation} ${isMobileNavShow && styles.active
            }`}
        >
          <ul>
            <li onClick={() => setIsMobileNavShow(false)}>
              <Link to="/">Home</Link>
            </li>
            <li onClick={() => setIsMobileNavShow(false)}>
              <Link to="/about">About</Link>
            </li>
            <li onClick={() => setIsMobileNavShow(false)}>
              <Link to="/dashboard">My Dashboard</Link>
            </li>
            <li className={styles.buttonWrapperMobile}>
              {isLogin ? (
                <Button
                  label="Log Out"
                  color="primary"
                  onClick={handleLogout}
                />
              ) : (
                <>
                  <Button
                    label="Log In"
                    color="primary"
                    onClick={() => setShowLoginModal(true)}
                  />
                  <Button
                    label="Sign Up"
                    color="secondary"
                    className={styles.btnSignup}
                  />
                </>
              )}
            </li>
          </ul>
        </div>
        <span className={styles.hamburgerIcon} onClick={handleToggleHamburger}>
          <FontAwesomeIcon icon={faBars} />
        </span>
      </div>
    </div>
  );
}
